import { Injectable } from '@angular/core';
import { Geocoder, GeocoderResult, ILatLng } from '@ionic-native/google-maps';
import { Platform } from 'ionic-angular';

declare var google: any;

@Injectable()
export class MapService {

	constructor(
		private platform: Platform
	) { }

	getGeocoderInfo(address: string): Promise<ILatLng> {
		return new Promise(async (resolve, reject) => {
			try {
				if (address) {
					address = address.replace(/(<([^>]+)>)/gi, "");
					if (this.platform.is("cordova")) {
						const geocoderResult: Array<GeocoderResult> = await Geocoder.geocode({
							address: address
						}) as Array<GeocoderResult>;
						if (geocoderResult && geocoderResult.length) {
							resolve(geocoderResult[0].position);
						} else {
							reject(null);
						}
					} else {
						if (location.hostname !== "localhost") {
							const geocoder: any = new google.maps.Geocoder();
							geocoder.geocode({ address: address }, (results, status) => {
								if (status === 'OK') {
									if (results && results.length > 0) {
										const addressResponse: any = results[0];
										if (addressResponse.geometry && addressResponse.geometry.location) {
											resolve({
												lat: addressResponse.geometry.location.lat(),
												lng: addressResponse.geometry.location.lng()
											});
											return;
										}
									}
								} else {
									console.log('Geocode was not successful for the following reason: ' + status);
								}
								reject(null);
							});
						} else {
							reject(null);
						}
					}
				} else {
					reject(null);
				}
			} catch (error) {
				console.error(error);
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/map/map.service.ts